// ─── Landing page: Meta cold traffic, Oct 2026 (sections/custom-lp-*.liquid) ───
// Loaded (deferred) by custom-lp-coffee and custom-lp-buybar. Both may include the
// tag, so the guard keeps it to one run.
(function () {
  if (window.__ifLandingPage) return;
  window.__ifLandingPage = true;

  var routes = (window.theme && window.theme.routes) || {};
  var cartAddUrl = routes.cartAdd || '/cart/add.js';
  var cartJsUrl = routes.cart || '/cart.js';
  var cartPageUrl = routes.cartPage || '/cart';

  function hasDrawer() {
    var type = window.theme && window.theme.settings && window.theme.settings.cartType;
    return type === 'drawer' && !!document.getElementById('CartDrawer');
  }

  function openCart() {
    if (hasDrawer()) {
      document.dispatchEvent(new CustomEvent('cart:open'));
    } else {
      window.location.href = cartPageUrl;
    }
  }

  // Cart count for the sticky bar. A failed read leaves the bar as it was and logs it.
  function refreshCount() {
    return fetch(cartJsUrl, { headers: { Accept: 'application/json' } })
      .then(function (r) {
        if (!r.ok) throw new Error('cart.js ' + r.status);
        return r.json();
      })
      .then(function (cart) {
        document.dispatchEvent(new CustomEvent('lp:cart-count', { detail: { count: cart.item_count } }));
        return cart.item_count;
      })
      .catch(function (err) { console.error('[landing page] cart count', err); });
  }

  // ── Add to cart (progressive enhancement over a normal /cart/add form) ────
  // Handled on the button click so no native form submit fires: Shopify's
  // automatic form tracking turns that submit into a partial
  // product_added_to_cart event that one installed web pixel cannot read.
  // The fetch below still produces the full, normal add-to-cart event.
  document.addEventListener('click', function (evt) {
    var btn = evt.target.closest && evt.target.closest('form[data-lp-add] [type="submit"]');
    if (!btn) return;
    evt.preventDefault();
    addToCart(btn.form);
  });
  document.addEventListener('submit', function (evt) {
    var form = evt.target;
    if (!form.matches || !form.matches('form[data-lp-add]')) return;
    evt.preventDefault();
    addToCart(form);
  });

  function addToCart(form) {
    var btn = form.querySelector('[type="submit"]');
    if (btn.disabled) return;
    var status = form.querySelector('[data-lp-status]');
    var label = btn.getAttribute('data-label') || btn.textContent;
    btn.disabled = true;
    btn.setAttribute('aria-busy', 'true');
    btn.textContent = btn.getAttribute('data-adding') || 'Adding';
    status.textContent = '';
    status.classList.remove('is-error');

    fetch(cartAddUrl, {
      method: 'POST',
      body: new FormData(form),
      headers: { 'X-Requested-With': 'XMLHttpRequest', Accept: 'application/json' }
    })
      .then(function (r) {
        return r.json().then(function (data) {
          if (!r.ok || data.status) throw new Error(data.description || data.message || 'Could not add to cart');
          return data;
        });
      })
      .then(function (item) {
        btn.textContent = btn.getAttribute('data-added') || 'Added';
        status.textContent = (btn.getAttribute('data-added-status') || 'Added to cart') + ': ' + item.product_title + ', ' + item.variant_title;
        if (!hasDrawer()) {
          window.location.href = cartPageUrl;
          return;
        }
        // Open the updated drawer immediately after the successful add.
        form.dispatchEvent(new CustomEvent('ajaxProduct:added', { detail: { product: item, addToCartBtn: btn }, bubbles: true }));
        refreshCount();
        setTimeout(function () { btn.textContent = label; }, 2200);
      })
      .catch(function (err) {
        console.error('[landing page] add to cart', err);
        status.textContent = err.message;
        status.classList.add('is-error');
        btn.textContent = label;
      })
      .then(function () {
        btn.disabled = false;
        btn.removeAttribute('aria-busy');
      });
  }

  // ── Sticky mobile bar ─────────────────────────────────────────────────────
  // Shows once the hero button has scrolled away, hides while any row's Add
  // button (or the coffee list header) is on screen, and after an add it turns
  // into "View cart (n)".
  function initBar() {
    var bar = document.querySelector('[data-lp-buybar]');
    if (!bar || !('IntersectionObserver' in window)) return;
    var link = bar.querySelector('[data-lp-buybar-link]');
    var text = bar.querySelector('[data-lp-buybar-text]');
    var heroCta = document.querySelector('[data-lp-hero-cta]');
    var watched = Array.prototype.slice.call(document.querySelectorAll('.lp-row [type="submit"], .lp-final [data-lp-final-cta]'));
    var heroVisible = !!heroCta;
    var onScreen = new Set();

    function render() {
      var show = !heroVisible && onScreen.size === 0;
      bar.classList.toggle('is-visible', show);
      bar.setAttribute('aria-hidden', show ? 'false' : 'true');
      if (show) bar.removeAttribute('inert'); else bar.setAttribute('inert', '');
    }

    if (heroCta) {
      new IntersectionObserver(function (entries) {
        heroVisible = entries[0].isIntersecting;
        render();
      }).observe(heroCta);
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) onScreen.add(e.target); else onScreen.delete(e.target);
      });
      render();
    });
    watched.forEach(function (el) { io.observe(el); });

    document.addEventListener('lp:cart-count', function (e) {
      var n = e.detail.count;
      if (!n) return;
      link.textContent = (bar.getAttribute('data-view-cart') || 'View cart') + ' (' + n + ')';
      link.setAttribute('href', cartPageUrl);
      link.setAttribute('data-lp-open-cart', '');
      if (text && bar.getAttribute('data-after-add')) text.textContent = bar.getAttribute('data-after-add');
    });
    link.addEventListener('click', function (e) {
      if (!link.hasAttribute('data-lp-open-cart')) return;
      e.preventDefault();
      openCart();
    });
    render();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initBar);
  else initBar();
})();
